// extracted by mini-css-extract-plugin
module.exports = {"hero_wrapper":"Hero_hero_wrapper__3Y_f9","duckScene":"Hero_duckScene__LJGf3","textContainer":"Hero_textContainer__3kXGi","duck_trigger":"Hero_duck_trigger__ZmVof"};